<template>
  <div class="backdrop">
    <div class="backdrop-top">
      <div class="title-box">
        <img src="../../../assets/images/return.png" @click="$router.go(-1)"><span>资产盘盈</span>
      </div>
      <div class="list-wrapper">
        <div class="row-item">
          <label>物品档案<strong>*</strong></label>
          <input type="text" v-model="detail.goods_name" placeholder="请选择物品档案" @click="selectGoods()">
          <img src="../../../assets/images/right_jt.png">
        </div>
        <div class="row-item">
          <label>资产编码</label>
          <input type="text" v-model="detail.asset_num" placeholder="请输入资产编码" >
        </div>
        <div class="row-item" @click="areaClick">
          <label>存放位置<strong>*</strong></label>
          <input type="text" v-model="detail.new_area_name" placeholder="请选择存放位置" >
          <img src="../../../assets/images/right_jt.png">
        </div>
        <div class="row-item" @click="stateClick">
          <label>状态<strong>*</strong></label>
          <input type="text" v-model="detail.new_status_info" placeholder="请选择存放位置" >
          <img src="../../../assets/images/right_jt.png">
        </div>
        <div class="row-item" @click="userClick">
          <label>使用人</label>
          <input type="text" v-model="detail.new_keeper_member_name" placeholder="请选择使用人" >
          <img src="../../../assets/images/right_jt.png">
        </div>
        <div class="row-item">
          <label>盘点备注</label>
          <input type="text" v-model="detail.remark" placeholder="请输入盘点备注" >
        </div>
      </div>
    </div>
    <button class="preserve" @click="save()">保存盘点</button>

    <!-- 选择状态 -->
    <div class="select-mask" v-if="statePopup">
      <div class="select-mask-blank" @click="clickBlank"></div>
      <div class="select-mask-inner">
        <div class="select-mask-content">
          <div class="head-mask">选择状态<img class="close-mask" @click="stateClose" src="../../../assets/images/close.png"></div>
          <el-tree :data="stateData" :props="defaultProps" @node-click="selectStatus"></el-tree>
        </div>
      </div>
    </div>

    <!-- 存放位置 -->
    <div class="select-mask" v-if="areaPopup">
      <div class="select-mask-blank" @click="clickBlank"></div>
      <div class="select-mask-inner">
        <div class="select-mask-content">
          <div class="head-mask">选择存放位置<img class="close-mask" @click="areaClose" src="../../../assets/images/close.png"></div>
          <el-tree :data="areaData" :props="defaultProps" @node-click="selectArea"></el-tree>
        </div>
      </div>
    </div>

    <!-- 选择使用人 -->
    <div class="select-mask" v-if="userPopup">
      <div class="select-mask-blank" @click="clickBlank"></div>
      <div class="select-mask-inner">
        <div class="select-mask-content">
          <div class="head-mask">选择使用人<img class="close-mask" @click="userClose" src="../../../assets/images/close.png"></div>
          <div class="search-box" style="padding: 15px 0">
            <input type="text" v-model="userKeywords" placeholder="请输入姓名/手机号" @keyup.enter="findUser" @input="findUser">
          </div>
          <el-tree :data="userData" :props="defaultProps" @node-click="selectKeeper"></el-tree>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'materialAdd',
  metaInfo: {
    title: '资产盘盈'
  },
  data () {
    return {
      stocktaking_id: 0,
      detail: {},
      areaPopup: false, // 存放位置
      areaData: [],
      userPopup: false, // 使用人
      userData: [],
      allUserData: [],
      userKeywords: '',
      statePopup: false, // 状态
      stateData: [
        {id: 1, label: '闲置'},
        {id: 2, label: '领用'},
        {id: 3, label: '借出'},
        {id: 4, label: '转租'},
        {id: 5, label: '维修'}
      ],
      defaultProps: {
        children: 'children',
        label: 'label'
      }
    }
  },
  computed: {
    ...mapState(['villageId', 'memberId'])
  },
  created () {
    // 解决安卓软键盘弹出布局问题
    let bodyHeight = document.documentElement.clientHeight + 'px'
    window.addEventListener('resize', () => {
      document.body.style.height = bodyHeight
    })

    console.log(this.$route.query)
    this.stocktaking_id = this.$route.query.stocktaking_id
    if (this.$route.query.detail) {
      this.detail = JSON.parse(this.$route.query.detail)
    }
    if (this.$route.query.goods_id) {
      this.detail.goods_id = this.$route.query.goods_id
    }
    if (this.$route.query.goods_name) {
      this.detail.goods_name = this.$route.query.goods_name
    }
    if (this.$route.query.code_asset_num) {
      this.detail.asset_num = this.$route.query.code_asset_num
    }
    this.getAreaTree()
    this.getUserTree()
  },
  methods: {
    getAreaTree () {
      this.axios.post('/wechat/basic_info/getAreaTree', {
        member_id: this.memberId,
        village_id: this.villageId
      }).then((res) => {
        if (res.data.status === 1) {
          this.areaData = res.data.data
        }
      })
    },
    getUserTree () {
      this.axios.post('/wechat/basic_info/getVillageMemberTree', {
        member_id: this.memberId,
        village_id: this.villageId
      }).then((res) => {
        if (res.data.status === 1) {
          this.allUserData = res.data.data
          this.userData = res.data.data
        }
      })
    },
    findUser () {
      this.userData = []
      var keywords = this.userKeywords
      let that = this
      this.allUserData.forEach(function (detail) {
        if (detail.label.indexOf(keywords) !== -1) {
          that.userData.push(detail)
        }
      })
    },
    // 保存
    save () {
      if (!this.detail.goods_id) {
        this.$toast({
          message: '请选择物品档案',
          duration: 5000
        })
        return false
      }
      if (!this.detail.new_area_id) {
        this.$toast({
          message: '请选择存放位置',
          duration: 5000
        })
        return false
      }
      if (!this.detail.new_status) {
        this.$toast({
          message: '请选择状态',
          duration: 5000
        })
        return false
      }
      var commitDetail = {}
      commitDetail.stocktake_status = 2 // 盘盈
      commitDetail.goods_id = this.detail.goods_id
      commitDetail.new_area_id = this.detail.new_area_id
      commitDetail.new_status = this.detail.new_status
      commitDetail.remark = this.detail.remark
      if (this.detail.asset_num) {
        commitDetail.asset_num = this.detail.asset_num
      }
      if (this.detail.new_keeper_member_id) {
        commitDetail.new_keeper_member_id = this.detail.new_keeper_member_id
      }
      this.axios.post('/wechat/stocktaking/editAssetStocktaking', {
        member_id: this.memberId,
        village_id: this.villageId,
        stocktaking_id: this.stocktaking_id,
        goods: JSON.stringify([commitDetail])
      }).then((res) => {
        if (res.data.status === 1) {
          this.$toast({
            message: '保存成功',
            duration: 5000
          })
          this.$router.push({name: 'AssetStocktakingInfo', query: {stocktaking_id: this.stocktaking_id}})
        } else {
          this.$toast({
            message: res.data.info,
            duration: 5000
          })
        }
      }).catch(() => {
        this.$toast({
          message: '网络错误',
          duration: 5000
        })
      })
    },
    // 点击使用人
    userClick () {
      this.userPopup = true
    },
    // 关闭使用人弹出
    userClose () {
      this.userPopup = false
    },
    // 点击状态
    stateClick () {
      this.statePopup = true
    },
    // 关闭状态弹出
    stateClose () {
      this.statePopup = false
    },
    // 点击存放位置
    areaClick () {
      this.areaPopup = true
    },
    // 关闭存放位置弹出
    areaClose () {
      this.areaPopup = false
    },
    // 点击空白地方关闭
    clickBlank () {
      this.userPopup = false
      this.statePopup = false
      this.areaPopup = false
    },
    handleNodeClick1 (data) {
      console.log(data)
    },
    handleNodeClick2 (data) {
      console.log(data)
      if (data.$treeNodeId === 5) {
        console.log(data.label)
      }
    },
    handleNodeClick3 (data) {
      console.log(data)
    },
    selectStatus (data) {
      this.detail.new_status = data.id
      this.detail.new_status_info = data.label
      this.clickBlank()
    },
    selectArea (data) {
      this.detail.new_area_id = data.id
      this.detail.new_area_name = data.label
      this.clickBlank()
    },
    selectKeeper (data) {
      this.detail.new_keeper_member_id = data.id
      this.detail.new_keeper_member_name = data.label.split('-')[0]
      this.clickBlank()
    },
    // 选择物品档案
    selectGoods () {
      var returnQuery = {} // 选完物品跳回时需携带参数
      returnQuery.stocktaking_id = this.stocktaking_id
      returnQuery.detail = JSON.stringify(this.detail)
      this.$router.push({name: 'GoodsList', query: {goods_type: 2, goods_type_clickable: 0, return_page: 'AssetStocktakingProfit', return_query: JSON.stringify(returnQuery)}})
    }
  }
}
</script>
<style scoped>
.backdrop {
  background-color: #f6f6f6;
  overflow: hidden;
}
.backdrop-top {
  height: calc(100% - 50px);
  overflow-y: auto;
}
.preserve {
  width: 100%;
  height: 50px;
  border: none;
  font-size: 16px;
  letter-spacing: 2px;
  color: #ffffff;
  background-color: #7090fd;
}
.list-wrapper .list-detail {
  background-color: #ffffff;
  padding: 10px;
}
.list-wrapper .list-detail .detail-box {
  background-color: #f6f6f6;
  padding: 10px;
}
.list-wrapper .list-detail .detail-box .title {
  font-weight: 600;
  font-size: 16px;
}
.list-wrapper .list-detail .detail-box .describe {
  font-size: 14px;
  margin-top: 10px;
}
.list-wrapper .list-detail .detail-box .describe label {
  display: inline-block;
  width: 80px;
  color: #666;
}
.list-wrapper .row-item {
  display: flex;
  /* margin: 0 15px; */
  padding: 10px 15px;
  border-bottom: 1px solid #f6f6f6;
  font-size: 15px;
  background-color: #ffffff;
}
.list-wrapper .row-item input {
  flex: 1;
  width: 100%;
  border: none;
  outline: none;
  font-size: 15px;
  text-align: right;
  padding: 0;
}
.list-wrapper .row-item img {
  width: 12px;
  height: 12px;
  vertical-align: top;
  padding: 5px 0 0 5px;
}
.select-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 1;
}
.select-mask .select-mask-blank {
  width: 100%;
  height: 100%;
}
.select-mask .select-mask-inner {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #ffffff;
  font-size: 15px;
  height: 300px;
  overflow-y: auto;
}
.select-mask .select-mask-inner .select-mask-content {
  padding: 0 15px;
}
.select-mask .select-mask-inner .head-mask {
  text-align: center;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #f6f6f6;
  position: relative;
}
.select-mask .select-mask-inner .head-mask .close-mask {
  width: 18px;
  height: 18px;
  position: absolute;
  top: 12px;
  right: 10px;
}
.select-mask .select-mask-inner .select-mask-content .level {
  border-bottom: 1px solid #f6f6f6;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  position: relative;
}
.select-mask .select-mask-inner .select-mask-content label {
  display: block;
  border-bottom: 1px solid #f6f6f6;
  padding: 5px 15px;
}
>>>
.mint-switch-core {
  width: 42px;
  height: 22px;
}
>>>
.mint-switch-core::before {
  width: 40px;
  height: 20px;
}
>>>
.mint-switch-core::after {
  width: 20px;
  height: 20px;
}
>>>
.el-tree-node__expand-icon {
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/Material/AssetStocktaking/AssetStocktakingProfit.vue